import '@firebase/storage-compat';
//# sourceMappingURL=index.esm.js.map
